import { render, staticRenderFns } from "./HighIncomeExclusionPopup.vue?vue&type=template&id=9a29c4fa&scoped=true"
import script from "./HighIncomeExclusionPopup.vue?vue&type=script&lang=js"
export * from "./HighIncomeExclusionPopup.vue?vue&type=script&lang=js"
import style0 from "./HighIncomeExclusionPopup.vue?vue&type=style&index=0&id=9a29c4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a29c4fa",
  null
  
)

export default component.exports